import React from "react";
import {connect} from "react-redux";
import ErrorHandler from "../../class/ErrorHandler";
import commonMethod from '../../lib/commonMethod'
import  * as requestLib from '../../lib/requestLib'
import cookie from 'react-cookies'
import Refresh from '../../components/Refresh'


class ShareUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accessToken : null,
            shareUser:null,
            loading:true,
        } 

        this.errorHandler = new ErrorHandler(this);
        this.baseUrl = requestLib.getUrl();
    }

    componentDidMount() {
        this.getShareUser();
    }

    componentDidUpdate() {

        if(this.props.isRefresh) {

            this.getShareUser();
            

        }
    }

    getShareUser() {
        // 공유사용자 get
        let accessToken = cookie.load('accessToken')

        commonMethod.requestGetWithToken('dashboard/config/members', accessToken, this, res => {

            let shareUser = [];

            if(res.member) {
                let member = res.member;
                for(let i=0; i<member.length; i++) {
                    
                    let homeIndex = shareUser.findIndex(home => home.homeId === member[i].homeId);
                    
                    if(homeIndex!==-1) {
                        shareUser[homeIndex].user.push(member[i])
                    } else {
                        shareUser.push({
                            homeId:member[i].homeId,
                            name:member[i].homeName,
                            user:[member[i]]
                        })
                    }
                    
                }
            }

            this.setState({shareUser:shareUser, loading:false});
            this.props.setIsRefresh(false);

        });
        

        
 
    }

    render() {

        let shareUser = this.state.shareUser;
        
        try {
            return (
                <div className="share-user">
                    {(shareUser && shareUser.length!==0) && shareUser.map((v, k)=>{
                        let user = v.user;
                        return (
                            <div className="location-list" key={v.homeId}>
                                <h4>{v.name}</h4>
                                <ul>
                                    {(user && user.length!==0) && user.map((u, i)=> {
                                        return (
                                            <li key={i}>
                                                <h5>{u.name}</h5>
                                                <span className={u.admin ? "manager" : ""}>
                                                    {u.admin ? "관리자" : "일반구성원"}
                                                </span>
                                                <p>{u.memberAccount}</p>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        )
                    })}
                    {this.state.loading && <Refresh height100={!shareUser || shareUser.length===0} />}
                </div>
            )
        } catch (error) {
            console.log(error)
            // this.errorHandler.processError(error);
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        accessToken: state.hejhome.accessToken, 
        isRefresh: state.hejhome.isRefresh, 
    }
}


// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
    setIsRefresh: (bool) => dispatch({
        type: 'setIsRefresh',
        isRefresh: bool,
    }),
});

ShareUser = connect(mapStateToProps, mapDispatchToProps)(ShareUser);


export default ShareUser;
